export const equalsIgnoreCase = (a, b) => {
  a = a ?? '';
  b = b ?? '';
  return a.toLowerCase() === b.toLowerCase();
};